import type {ViewMode} from 'api/types';
import {ViewModes} from '../types';

export const isViewMode = (value: unknown): value is ViewMode =>
  typeof value === 'string' && ViewModes.includes(value as ViewMode);
